<footer class="funnel5-footer">
    <div class="col-12 text-center mb-3">
      <img loading="lazy" src="assets/images/funnels/logo-app-v2.svg" class="logo-loan-approval" loading="lazy" priority="low">
    </div>
    <div class="col-12 text-center">
      <small class="text-white">
        <p>*Your lender and insurer might use a different scoring model, or another type of credit score altogether.
        </p>
        <p>**Scores and rankings shown above are examples only.</p>
        <a class="text-decoration-none text-white fw-bold mx-1" routerLink="/terms" target="_blank"
          id="link-terms-and-conditions">Terms & Conditions</a> |
        <a class="text-decoration-none text-white fw-bold mx-1" routerLink="/privacy" target="_blank"
          id="link-privacy-policy">Privacy Policy</a> |
        <a class="text-decoration-none text-white fw-bold mx-1" routerLink="/contact" target="_blank"
          id="link-contact-us">Contact Us</a>
        <br>
      </small>
    </div>
    <div class="col-12">
      <small>
        <p class="p-3 m-0 text-white">© {{ currentYear }} {{ brandResources.companyTitle! }}. All rights reserved.
        </p>
      </small>
    </div>
  </footer>